import { Card } from '../card';
import { Student } from '../student';

export class StudentCardSelection {
  student: Student;
  availableCards: Card[];
  selectedCard?: Card;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-family/student-card-selection.model.ts